import { render, staticRenderFns } from "./AlertWarning.vue?vue&type=template&id=6b9d3ab0"
import script from "./AlertWarning.vue?vue&type=script&lang=js"
export * from "./AlertWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports